import React from 'react';

/* What the membership type someone has picked actually covers, in the
   club's own words, shown right under the dropdown. A list of names and
   prices does not tell a new member whether they want "Social" or
   "Limited" — this does.

   Nothing is shown until a type is picked, or when the club has written
   nothing for it. */
function MembershipTypeInfo({ type, descriptions, pricing }) {
  const text = type && descriptions ? descriptions[type] : '';
  if (!text) return null;
  const price = pricing && Number.isFinite(Number(pricing[type])) && pricing[type] !== ''
    ? Number(pricing[type])
    : null;
  return (
    <div className="membership-type-info" role="note" aria-live="polite">
      <div className="membership-type-info-head">
        <strong>{type}</strong>
        {price !== null && <span>{price > 0 ? `$${price.toFixed(2).replace(/\.00$/, '')} a year` : 'Free'}</span>}
      </div>
      <p>{text}</p>
    </div>
  );
}

export default MembershipTypeInfo;
